import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/QUALIFICATION';

export const {action: showNew} = createAction(
    `${domain}/SHOW_NEW`,
    (institutionSetId: string, employeeId: string, refetchQuery: any) => ({institutionSetId, employeeId, refetchQuery}),
);

export const {action: showExisting} = createAction(
    `${domain}/SHOW_EXISTING`,
    (
        institutionSetId: string,
        qualificationAssignmentId: string,
        canEdit: boolean,
        canDelete: boolean,
        refetchQuery: any,
    ) => ({institutionSetId, qualificationAssignmentId, canEdit, canDelete, refetchQuery}),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: selectType} = createAction(`${domain}/SELECT_TYPE`, (typeId: string) => ({typeId}));
